import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";

const DeliverySettings = ({
  deliveryPayData,
  setDeliveryPayData,
  newRange,
  setNewRange,
  handleCombinedSubmit,
  deliveryRanges = [],
  deleteRange,
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const [originalPercent, setOriginalPercent] = useState("");
  const [originalNewRange, setOriginalNewRange] = useState([]);

  // Store original values once on mount
  useEffect(() => {
    if (deliveryPayData?.delivery_percentage !== undefined) {
      setOriginalPercent(deliveryPayData.delivery_percentage);
    }
    if (newRange?.length) {
      setOriginalNewRange(newRange.map((r) => ({ ...r })));
    }
  }, []);

  useEffect(() => {
    const percentChanged =
      deliveryPayData?.delivery_percentage !== originalPercent;

    const filterFilled = (arr) =>
      arr.filter((r) => r.min_km !== "" || r.max_km !== "" || r.price !== "");

    const cleanedNewRange = filterFilled(newRange);
    const cleanedOriginalRange = filterFilled(originalNewRange);

    const rangeChanged =
      JSON.stringify(cleanedNewRange) !== JSON.stringify(cleanedOriginalRange);

    setHasChanges(percentChanged || rangeChanged);
  }, [deliveryPayData, newRange, originalPercent, originalNewRange]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeliveryPayData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRangeChange = (index, field, value) => {
    const updated = [...newRange];
    updated[index][field] = value;
    setNewRange(updated);
  };

  // Only add new row if last one is filled
  const addRange = () => {
    const last = newRange[newRange.length - 1];
    if (!last || (last.min_km && last.max_km && last.price)) {
      setNewRange((prev) => [...prev, { min_km: "", max_km: "", price: "" }]);
    }
  };

  const removeRange = (index) => {
    setNewRange((prev) => prev.filter((_, i) => i !== index));
  };

  // Optional: Sanitize data before submitting
  const handleSafeSubmit = () => {
    const cleanedRanges = newRange.filter(
      (r) => r.min_km !== "" && r.max_km !== "" && r.price !== ""
    );
    // Call external handler
    handleCombinedSubmit({
      ...deliveryPayData,
      delivery_ranges: cleanedRanges,
    });
  };

  return (
    <div className="profile-form-container">
      {/* Pay Before % */}
      <div className="profile-form-group">
        <label className="profile-form-label">Pay Before Percentage (%)</label>
        <input
          type="number"
          name="delivery_percentage"
          value={deliveryPayData.delivery_percentage || ""}
          onChange={handleChange}
          className="profile-form-input"
          placeholder="e.g. 50"
        />
      </div>

      {/* Existing Delivery Ranges */}
      {deliveryRanges.length > 0 && (
        <div className="profile-form-group full-span">
          <label className="profile-form-label">Saved Delivery Ranges</label>
          {deliveryRanges.map((range) => (
            <div className="delivery-range-row saved-row" key={range.id}>
              <span className="readonly-text">Min: {range.min_kilometer} km</span>
              <span className="readonly-text">Max: {range.max_kilometer} km</span>
              <span className="readonly-text">Charge: ₹{range.freedelivery_price}</span>
              <button
                className="range-icon-btn remove-btn"
                onClick={() => deleteRange(range.id)}
                type="button"
              >
                <Trash2 size={18} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* New Ranges Input */}
      <div className="profile-form-group full-span">
        <label className="profile-form-label">Add New Delivery Ranges</label>

        {newRange.map((range, index) => (
          <div className="delivery-range-row" key={index}>
            <input
              type="number"
              placeholder="Min KM"
              value={range.min_km}
              onChange={(e) =>
                handleRangeChange(index, "min_km", e.target.value)
              }
              className="profile-form-input small-input"
            />
            <input
              type="number"
              placeholder="Max KM"
              value={range.max_km}
              onChange={(e) =>
                handleRangeChange(index, "max_km", e.target.value)
              }
              className="profile-form-input small-input"
            />
            <input
              type="number"
              placeholder="Charge ₹"
              value={range.price}
              onChange={(e) =>
                handleRangeChange(index, "price", e.target.value)
              }
              className="profile-form-input small-input"
            />
            <button
              className="range-icon-btn remove-btn"
              onClick={() => removeRange(index)}
              type="button"
            >
              <Trash2 size={18} />
            </button>
          </div>
        ))}

        <button
          type="button"
          className="range-icon-btn add-range-btn"
          onClick={addRange}
        >
          <Plus size={18} className="plus-icon" />
          Add Range
        </button>
      </div>

      {/* Save Button */}
      {hasChanges && (
        <div className="profile-form-group full-span">
          <button className="profile-save-btn" onClick={handleSafeSubmit}>
            Save Changes
          </button>
        </div>
      )}
    </div>
  );
};

export default DeliverySettings;
